import { Navigate, useLocation } from "react-router-dom";
import EventPublicPage from "@/pages/public/EventPublicPage";
import { LanguageRoute } from "./LanguageRoute";
import NotFound from "@/pages/NotFound";

/**
 * Handler for /@{slug} routes
 * This component intercepts routes starting with /@ and renders EventPublicPage
 * For other routes, it delegates to LanguageRoute or shows 404
 */
export function AtRouteHandler() {
  const location = useLocation();

  // If path starts with /@, render EventPublicPage directly
  if (location.pathname.startsWith('/@')) {
    const raw = location.pathname.slice(2); // strip leading "/@"
    const slug = raw.split(/[/?#]/)[0]?.toLowerCase() ?? "";

    // Defensive: never treat reserved slugs as event pages.
    // This also protects against accidental redirects (e.g. /{locale}/admin) becoming /@admin.
    const RESERVED_SLUGS = new Set([
      "admin",
      "management",
      "login",
      "register",
      "logout",
      "payment",
      "payments",
      "evenimente",
      "events",
      "pachete",
      "plati",
      "conturi-conectate",
      "connected-accounts",
      "api",
      "dev",
      // JUB-123 / JUB-100: public content routes (mirrors EventSlugService::RESERVED_EVENT_SLUGS)
      "blog",
      "faq",
      "cookies-policy",
      "data-processing-notice",
      "superadmin",
      "email-verification",
      "forgot-password",
      "rsvp",
      "campaign",
      "editeaza-eveniment",
      "edit-event",
      "payment-settings",
      "setari",
      "settings",
    ]);

    if (!slug || RESERVED_SLUGS.has(slug)) {
      return <Navigate to="/ro/evenimente" replace />;
    }

    return <EventPublicPage />;
  }

  // If path starts with /ro or /en, delegate to LanguageRoute
  // LanguageRoute will handle nested routes via its own Routes
  if (location.pathname.startsWith('/ro') || location.pathname.startsWith('/en')) {
    return <LanguageRoute />;
  }

  // For root path, delegate to LanguageRoute (which will redirect to /ro)
  if (location.pathname === '/') {
    return <LanguageRoute />;
  }

  // For any other path that doesn't start with /@, /ro, or /en, show 404
  return <NotFound />;
}
